import { useEffect } from 'react';
import { useB2CModeStore, useCurrencyStore } from '../services/store';
import { useAuthStore } from '../services/store';
import { useIsUserRegisteredForCurrentTournament } from './useIsUserRegisteredForCurrentTournament.ts';

export const useCurrencyManaging = () => {
  const b2cMode = useB2CModeStore(({ mode }) => mode);
  const updateCurrencyByMode = useCurrencyStore(
    ({ updateCurrencyByMode }) => updateCurrencyByMode
  );
  const isAuthenticated = useAuthStore((state) => state.isAuthenticated);

  const { isPending, data: userIsRegisteredForCurrentTournament } =
    useIsUserRegisteredForCurrentTournament();

  useEffect(() => {
    updateCurrencyByMode(
      b2cMode,
      !isPending && !!userIsRegisteredForCurrentTournament
    );
  }, [
    b2cMode,
    isAuthenticated,
    isPending,
    userIsRegisteredForCurrentTournament,
    updateCurrencyByMode,
  ]);
};
